import { generateUtilityClass, generateUtilityClasses } from '../styles/classes';
export var promoBannerComponentName = 'QuantumPromoBanner';
export function getPromoBannerUtilityClass(slot) {
    return generateUtilityClass(promoBannerComponentName, slot);
}
export var promoBannerClasses = generateUtilityClasses(promoBannerComponentName, [
    'root',
    'content',
    'title',
    'description',
    'actions',
    'action',
    'primaryAction',
    'secondaryAction',
    'imageContainer',
    'image',
]);
